import { render, staticRenderFns } from "./feedList.vue?vue&type=template&id=53b68f5e&scoped=true"
import script from "./feedList.vue?vue&type=script&lang=js"
export * from "./feedList.vue?vue&type=script&lang=js"
import style0 from "./feedList.vue?vue&type=style&index=0&id=53b68f5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b68f5e",
  null
  
)

export default component.exports